import React from 'react';

const Wardrobe = () => {
    return (
        <div className="avatar-section">
            <h2>👗 Wardrobe</h2>
            <p>View all your owned items here.</p>
        </div>
    );
};

export default Wardrobe;